<!--  -->
<template>
  <div class="dialog-floor">
    <div class="dialog-box">
      <span class="close iconfont icon-guanbi" @click="close"></span>
      <div class="dialog-content">
        <div class="remit-head">請勾選匯出項目</div>
        <ul>
          <li v-for="(item,i) in arr" :key="i">
            <div v-if="item.type == 'default'">
              <span
                class="round"
                :class="{'select-color': selectNum == i}"
                @click="selectNum = i,itemData = item"
              ></span>
              <span>{{item.title}}</span>
            </div>
            <div v-else>
              <span
                class="round"
                :class="{'select-color': selectNum == i}"
                @click="selectNum = i,itemData = item"
              ></span>
              <span>{{item.title}}</span>
              <div class="slide-box">
                <span class="title">不退保證金</span>
                <span class="slide" @click="item.isSelect = !item.isSelect">
                  <span class="chunk" :class="[ item.isSelect ? 'chunk-r' : 'chunk-l' ]"></span>
                </span>
                <span class="title">退保證金</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="remit-foot">
          <div class="btn-box">
            <tw-btn title="送出" @click="remit"></tw-btn>
            <tw-btn title="取消" class="cancel" @click="close"></tw-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../../api/index.js";
import TwBtn from "../../tw-btn";

export default {
  name: "lookActivity",
  data() {
    return {
      selectNum: null,
      isSelect: false,
      arr: [],
      itemData: null
    };
  },

  components: {
    TwBtn
  },

  created() {
    // SignedOutList---approval  Item issuance statistics export
    // SignedInList---approval  Item receipt/issuance monthly report export
    // SignedStockList---  Item inventory table export
    // Month --- venue  monthly report export
    // Arrange--- venue  duty roster export
    // Quick--- venue  quick report export
    // Annual--- venue  annual income detail report export
    // SurveyNon--- venue  site inspection table - non-refundable deposit export
    // Survey--- venue  site inspection table - refundable deposit export
    let siteExport = [
      { type: "default", title: "月報表", url: "Month" },
      { type: "default", title: "輪值表", url: "Arrange" },
      { type: "default", title: "速報表", url: "Quick" },
      { type: "default", title: "年收入明細表", url: "Annual" },
      {
        type: "multiterm",
        title: "會勘表",
        isSelect: false,
        url1: "SurveyNon",
        url2: "Survey"
      }
    ];
    let signedExport = [
      { type: "default", title: "物品核發統計表", url: "SignedOutList" },
      { type: "default", title: "物品收發月報表", url: "SignedInList" },
      { type: "default", title: "物品盤點表", url: "SignedStockList" }
    ];
    if (this.remitType == "signed") {
      this.arr = signedExport;
    } else {
      this.arr = siteExport;
    }
  },
  methods: {
    remit() {
      if (this.itemData == null) {
        this.$alert("請勾選匯出項目", "提示", {
          confirmButtonText: "確定"
        });
        return;
      }
      let type;
      if (this.itemData.type != "default") {
        if (!this.itemData.isSelect) {
          type = this.itemData.url1;
        } else {
          type = this.itemData.url2;
        }
      } else {
        type = this.itemData.url;
      }
      this[`export${type}`]();
    },
    close() {
      this.$store.commit("SET_IS_SHOW_DIALOG");
    },
    exportMonth() {
      window.open(`${API.exportMonth}${this.beginDate}_${this.endDate}`);
      // this.$axios.get(`${API.exportMonth}${this.beginDate}_${this.endDate}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportArrange() {
      window.open(`${API.exportArrange}${this.beginDate}_${this.endDate}`);
      // this.$axios.get(`${API.exportArrange}${this.beginDate}_${this.endDate}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportQuick() {
      window.open(`${API.exportQuick}?ids=${this.ids}`);
      // this.$axios.get(`${API.exportQuick}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportAnnual() {
      window.open(`${API.exportAnnual}${this.beginDate}_${this.endDate}`);
      // this.$axios.get(`${API.exportAnnual}${this.beginDate}_${this.endDate}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportSurveyNon() {
      window.open(`${API.exportSurveyNon}?ids=${this.ids}`);
      // this.$axios.get(`${API.exportSurveyNon}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportSurvey() {
      window.open(`${API.exportSurvey}?ids=${this.ids}`);
      // this.$axios.get(`${API.exportSurvey}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportSignedOutList() {
      // console.log(
      //   `${API.exportSignedOutList}${this.beginDate}_${this.endDate}`
      // );

      window.open(
        `${API.exportSignedOutList}${this.beginDate}_${this.endDate}`
      );
      // this.$axios.get(`${API.exportSignedOutList}${this.beginDate}_${this.endDate}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportSignedInList() {
      window.open(`${API.exportSignedInList}${this.beginDate}_${this.endDate}`);
      // this.$axios.get(`${API.exportSignedInList}${this.beginDate}_${this.endDate}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    exportSignedStockList() {
      // console.log(`${API.exportSignedStockList}`);

      window.open(`${API.exportSignedStockList}`);
      // this.$axios.get(`${API.exportSignedStockList}`).then( res => {
      //     this.remitSuccess()
      // }).catch( err => {
      //     this.remitError();
      // })
    },
    remitSuccess() {
      this.$alert("匯出成功", "提示", {
        confirmButtonText: "確定",
        callback: action => {
          this.$store.state.isShowDialog = false;
        }
      });
    },
    remitError() {
      this.$alert("匯出失敗", "提示", {
        confirmButtonText: "確定"
      });
    }
  },

  computed: {
    remitType() {
      return this.$store.state.remitData.type;
    },
    beginDate() {
      return this.$store.state.remitData.beginDate;
    },
    endDate() {
      return this.$store.state.remitData.endDate;
    },
    ids() {
      var result = [];
      this.$store.state.storageSelectData.forEach(element => {
        return result.push(element.ID);
      });
      return result.join(",");
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-floor {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  .dialog-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 1.5rem;
    .close {
      position: absolute;
      right: -1.6rem;
      top: -1.6rem;
      display: inline-block;
      width: 3.2rem;
      height: 3.2rem;
      color: #44484c;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0px 0px 10px #ccc;
      font-size: 1.4rem;
      font-weight: 900;
      text-align: center;
      line-height: 3.2rem;
      cursor: pointer;
    }
  }
}

.dialog-content {
  padding: 4rem 5rem 4rem 5rem;
  .remit-head {
    font-size: 2.5rem;
    color: #2fbeea;
  }
  ul {
    margin-top: 3rem;
    li {
      height: 3.6rem;
      line-height: 3.6rem;
      span {
        display: inline-block;
        font-size: 1.4rem;
        vertical-align: middle;
      }
      .round {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.4rem;
        background: #bcbcbc;
        cursor: pointer;
        margin-right: 0.4rem;
      }
      .select-color {
        background: #000;
      }
      .slide-box {
        display: inline-block;
        margin-left: 0.5rem;
        user-select: none;
        .title {
          font-size: 1.2rem;
        }
        .slide {
          width: 2.8rem;
          height: 1.4rem;
          background: #bcbcbc;
          border-radius: 0.4rem;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
          margin: 0 0.5rem;
          .chunk {
            position: absolute;
            right: 0;
            width: 1.4rem;
            height: 1.4rem;
            background: #000;
            border-radius: 0.4rem;
            transition: 1s linear;
          }
          .chunk-l {
            left: 0;
          }
          .chunk-r {
            right: 0;
          }
        }
      }
    }
  }
  .remit-foot {
    margin-top: 6rem;
    text-align: center;
    .btn-box {
      display: inline-block;
      .cancel {
        margin-left: 1rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/venueRental/remit.vue